import { ROUTE_NAMES } from '~/constants/routes'

export function getListingCreateRoute(onboardingCompleted: boolean) {
  return onboardingCompleted
    ? ROUTE_NAMES.LISTINGS.PRODUCT.SEARCH
    : ROUTE_NAMES.ONBOARDING.LISTINGS.CREATE.PRODUCT.SEARCH
}

/**
 * Returns the product creation route based on the feature flag.
 * If the feature flag is enabled, returns the new product creation page.
 * Otherwise, returns the legacy Badoom route.
 */
export function getProductCreateRoute(
  isProductCreationRevampEnabled: boolean,
): { name: string } {
  return isProductCreationRevampEnabled
    ? { name: ROUTE_NAMES.LISTINGS.PRODUCT.CREATE }
    : { name: ROUTE_NAMES.BADOOM.LISTINGS.PRODUCT.CREATE }
}

export function getActiveListingsRoute(onboardingCompleted: boolean) {
  const onboardingRoute = ROUTE_NAMES.ONBOARDING.LISTINGS.TABS.ACTIVE

  const listingsRoute = ROUTE_NAMES.LISTINGS.INDEX

  return onboardingCompleted ? listingsRoute : onboardingRoute
}

export function isGradeSupportingBatteryLevel(
  aestheticGrade: number | null | undefined,
) {
  // Premium grade (9) does not support battery level options
  return aestheticGrade !== 9
}
